import comp from "./EntityCohorts.js";
export default comp;
